import styled from 'styled-components';

export const BackToTopWrapper = styled.a`
    font-size: 20px;
    color: #fff;
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 50px;
    height: 50px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #3EC4D4;
    text-align: center;
    z-index: 99;
    -webkit-transition: all 0.3s ease-out 0s;
    -moz-transition: all 0.3s ease-out 0s;
    -ms-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    opacity: 0;
    visibility: hidden;

    &::after {
        content: none;
    }

    img {
        margin-top: 13px;
        margin-left: 5px;
        max-width: 34px;
        -webkit-transition: all 0.2s ease-in;
        -moz-transition: all 0.2s ease-in;
        -ms-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;

        &:hover {
            margin-top: 9px;
            margin-left: -4px;
        }
    }
`;